<template>
  <div class="master-material-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i class="fa fa-align-justify"></i>
              <strong v-if="item.id == ''">{{ $t('create') }}</strong>
              <strong v-else>{{ $t('edit') }}</strong>
              <div class="card-actions"></div>
            </div>
            <b-form class="row" v-if="item.id != null">
              <b-col align-self="center">
                <b-form-row>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('code')" :label-cols="2" :horizontal="true">
                      <b-form-input class="form-control" v-model="item.code"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('name')" :label-cols="2" :horizontal="true">
                      <b-form-input class="form-control" v-model="item.name"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('uom_name')" :label-cols="2" :horizontal="true">
                      <v-select v-model="item.uom_id" :options="uoms"></v-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('plucode')" :label-cols="2" :horizontal="true">
                      <b-form-input class="form-control" v-model="item.plucode"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('sku')" :label-cols="2" :horizontal="true">
                      <b-form-input
                        class="form-control"
                        v-model="item.sku"
                        placeholder="Ie. 224300006,213830015,213830014"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('usage')" :label-cols="2" :horizontal="true">
                      <b-form-input class="form-control" v-model="item.usage"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col cols="6">
                    <b-form-group
                      v-bind:label="$t('expired_in')"
                      :label-cols="2"
                      :horizontal="true"
                    >
                      <b-form-input class="form-control" v-model="item.expired_in"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('price')" :label-cols="2" :horizontal="true">
                      <b-form-input disabled class="form-control" v-model="item.price"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('active')" label-cols="2" :horizontal="true">
                      <c-switch
                        type="icon"
                        variant="primary"
                        v-bind="{on: '\uf00c', off: '\uf00d'}"
                        v-model="item.is_active"
                        v-bind:checked="item.is_active"
                        :value="1"
                        :uncheckedValue="0"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group v-bind:label="$t('daily_batch')" label-cols="2" :horizontal="true">
                      <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                v-model="item.is_daily_batch" v-bind:checked="item.is_daily_batch" :value="1" :uncheckedValue="0"/>
                    </b-form-group>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form>
            <template>
              <div>
                <b-button :disabled="!item.code || this.recipes.length === 0" @click="addNew">
                  Add new
                </b-button>
                <!-- Modal Component -->
                <b-modal id="modalPrevent" ref="my-modal" title="Add recipe detail" @ok="handleAdd">
                  <form @submit.stop.prevent="hideModal" id="add-recipe-detail">
                    <b-form-group>
                      <b-form-radio-group
                        id="choose-method"
                        v-model="selected"
                        name="radioSubComponent"
                      >
                        <b-form-radio value="true" v-on:change="switchTab(true)">Using material</b-form-radio>
                        <b-form-radio
                          value="false"
                          v-on:change="switchTab(false)"
                        >Using others recipe</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form id="using-material" v-if="isHidden">
                      <b-form-group
                        v-bind:label="$t('material')"
                        :label-cols="3"
                        :horizontal="true"
                      >
                        <v-select v-model="popup.material" :options="materials"></v-select>
                      </b-form-group>
                    </b-form>
                    <b-form id="using-others-recipe" v-if="!isHidden">
                      <b-form-group v-bind:label="$t('recipe')" :label-cols="3" :horizontal="true">
                        <v-select v-model="popup.recipe" :options="recipes"></v-select>
                      </b-form-group>
                    </b-form>
                    <b-form-group
                      v-bind:label="$t('recipe_detail_usage')"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input class="form-control" v-model="popup.recipe_detail_usage"></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-bind:label="$t('recipe_detail_status')"
                      label-cols="3"
                      :horizontal="true"
                    >
                      <c-switch
                        type="icon"
                        variant="primary"
                        v-bind="{on: '\uf00c', off: '\uf00d'}"
                        v-model="popup.recipe_detail_status"
                        :value="1"
                        :uncheckedValue="0"
                      />
                    </b-form-group>
                  </form>
                </b-modal>
              </div>
            </template>
            <div class="row">
              <template>
                <b-table :items="data_table" :fields="columns_table" ref="table">
                  <template v-for="(field, fieldKey) in formatted" :slot="field" slot-scope="row">
                    <button
                      :key="fieldKey + '-Edit'"
                      v-on:click="editRecipeDeTail(row.index, row.item)"
                      class="btn btn-sm btn-primary"
                    >Edit</button>
                    <button
                      :key="fieldKey + '-Remove'"
                      v-on:click="removeRecipeDeTail(row.index)"
                      class="btn btn-sm btn-danger"
                    >Remove</button>
                  </template>
                </b-table>
              </template>
            </div>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model}">
                <b-button variant="default">
                  <i class="fa fa-arrow-left"></i>
                  {{$t('back')}}
                </b-button>
              </router-link>
              <b-button
                variant="success"
                v-on:click="updateItem"
                v-if="id != null"
              >
                <!--                v-if="id != null && $auth.check(model + '.update')"-->
                <i class="fa fa-save"></i>
                {{$t('update')}}
              </b-button>
              <b-button
                variant="success"
                v-on:click="createItem"
                v-if="id == null"
              >
<!--                v-if="id == null && $auth.check(model + '.create')"-->
                <i class="fa fa-save"></i>
                {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
.switch {
  margin-bottom: 0px;
  margin-top: 7px;
  float: left;
  margin-right: 5px;
}
</style>
<script>
import cSwitch from "../../../../components/Switch";
import { getMasterRecipeList, get, create, update } from "@/api/master_recipe";
import { getMasterMaterialList } from "@/api/master_material";
import { getMasterRecipeDetailByRecipe } from "@/api/master_recipe_detail";
import { getMasterUomList } from "@/api/master_uom";
import { filter } from 'lodash';
export default {
  name: "MasterRecipeForm",
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch
  },
  computed: {},
  data: function() {
    return {
      model: "master_recipe",
      formatted: ["action"],
      item: {
        id: null,
        uom_id: "",
        code: "",
        plucode: "",
        sku: "",
        name: "",
        usage: "",
        expired_in: "",
        price: 0,
        is_active: 1,
        is_daily_batch: 1
      },
      material: {},
      popup: {
        material: "",
        recipe: "",
        recipe_detail_usage: "",
        recipe_detail_status: 1
      },
      languages: Object.keys(this.$i18n.messages),
      uoms: [],
      materials: [],
      list_materials: [],
      recipes: [],
      recipe_details: [],
      recipe_list: [],
      recipe_details_by_recipe: [],
      columns_table: [
        {
          key: "recipe_or_material_code",
          label: "Recipe / Material Code"
        },
        {
          key: "recipe_or_material_name",
          label: "Recipe / Material Name"
        },
        {
          key: "usage_detail",
          label: "Usage Detail"
        },
        {
          key: "uom"
        },
        {
          key: "status",
          formatter: value => {
            return parseInt(value) == 0 ? "Not active" : "Active";
          }
        },
        {
          key: "detail_price",
          label: "Price"
        },
        {
          key: "action"
        }
      ],
      data_table: [],
      selected: 1,
      isHidden: true,
      index: 0,
      is_edit: false,
      index_edit: ""
    };
  },
  methods: {
    showModal: function() {
      this.$refs["my-modal"].show();
    },
    switchTab: function(data) {
      if (data) {
        this.selected = true;
      } else {
        this.selected = false;
      }
      this.isHidden = data;
    },
    addNew: function() {
      this.showModal();
      this.clearForm();
      this.setRecipes();
    },
    removeRecipeDeTail: function(index) {
      this.item.price =
        parseInt(this.item.price) -
        parseInt(this.data_table[index].detail_price);
      this.data_table.splice(index, 1);
      this.recipe_details.splice(index, 1);
    },
    editRecipeDeTail: function(index, row) {
      this.is_edit = true;
      this.index_edit = index;
      this.recipe_details.forEach((item, key) => {
        if (key === index) {
          if (!item.other_recipe_id) {
            this.selected = true;
            this.popup.material = {
              value: item.material_id,
              label:
                row.recipe_or_material_code + "-" + row.recipe_or_material_name
            };
          } else {
            this.selected = false;
            this.popup.recipe = {
              value: item.other_recipe_id,
              label:
                row.recipe_or_material_code + "-" + row.recipe_or_material_name
            };
          }
          this.popup.recipe_detail_usage = item.usage;
          this.isHidden = this.selected;
          return;
        }
      });
      this.showModal();
    },
    clearForm() {
      this.selected = true;
      this.popup.material = "";
      this.popup.recipe_detail_usage = "";
      this.popup.recipe_detail_status = 1;
      this.popup.recipe = "";
    },
    handleAdd() {
      if (isNaN(this.popup.recipe_detail_usage)) {
        this.$notify({
          title: this.$t("error"),
          text: "Usage must be numeric!",
          type: "error"
        });
        return;
      }
      if (this.selected) {
        if (!this.popup.material) {
          this.$notify({
            title: this.$t("error"),
            text: "Please choose Material",
            type: "error"
          });
          return;
        }
        let data_display = {
          recipe_or_material_code: this.material.code,
          recipe_or_material_name: this.material.name,
          weight: this.material.recipe_rate,
          uom: this.material.uom_name,
          usage_detail: this.popup.recipe_detail_usage,
          status: this.popup.recipe_detail_status,
          detail_price: this.material.price
          // action: this.index
        };
        let data_save = {
          recipe_id: this.item.id,
          material_id: this.popup.material.value,
          other_recipe_id: "",
          weight: this.material.recipe_rate,
          price: this.material.price,
          usage: this.popup.recipe_detail_usage,
          is_active: this.popup.recipe_detail_status
        };
        if (this.is_edit) {
          const data_table = this.data_table;
          const recipe_details = this.recipe_details;
          data_table.forEach((item, key) => {
            if (key === this.index_edit) {
              this.item.price =
                parseInt(this.item.price) +
                parseInt(this.material.price) -
                parseInt(item.detail_price);
              Vue.set(this.data_table, key, data_display);
              return;
            }
          });
          recipe_details.forEach((item, key) => {
            if (key === this.index_edit) {
              Vue.set(this.recipe_details, key, data_save);
              return;
            }
          });
          this.is_edit = false;
          this.index_edit = "";
        } else {
          this.data_table.push(data_display);
          this.recipe_details.push(data_save);
          this.item.price =
            parseInt(this.item.price) + parseInt(this.material.price);
        }
        this.hideModal();
      } else {
        if (!this.popup.recipe) {
          this.$notify({
            title: this.$t("error"),
            text: "Please choose recipe",
            type: "error"
          });
          return;
        }
        // this.index = this.index + 1
        let recipe_display = [];
        for (let i in this.recipe_list) {
          if (this.recipe_list[i].id == this.popup.recipe.value) {
            recipe_display = this.recipe_list[i];
          }
        }
        let data_display = {
          recipe_or_material_code: recipe_display.code,
          recipe_or_material_name: recipe_display.name,
          weight: recipe_display.usage,
          uom: recipe_display.uom_name,
          usage_detail: this.popup.recipe_detail_usage,
          status: this.popup.recipe_detail_status,
          detail_price: recipe_display.price,
          // action: this.index,
          _rowVariant: "success"
        };
        let data_save = {
          recipe_id: this.item.id,
          material_id: "",
          other_recipe_id: this.popup.recipe.value,
          weight: recipe_display.usage,
          price: recipe_display.price,
          usage: this.popup.recipe_detail_usage,
          is_active: this.popup.recipe_detail_status
        };
        if (this.is_edit) {
          const data_table = this.data_table;
          const recipe_details = this.recipe_details;
          data_table.forEach((item, key) => {
            if (key === this.index_edit) {
              this.item.price =
                parseInt(this.item.price) +
                parseInt(recipe_display.price) -
                parseInt(item.detail_price);
              Vue.set(this.data_table, key, data_display);
              return;
            }
          });
          recipe_details.forEach((item, key) => {
            if (key === this.index_edit) {
              Vue.set(this.recipe_details, key, data_save);
              return;
            }
          });
          this.is_edit = false;
          this.index_edit = "";
        } else {
          this.data_table.push(data_display);
          this.recipe_details.push(data_save);
          this.item.price =
            parseInt(this.item.price) + parseInt(recipe_display.price);
        }
        this.hideModal();
      }
      this.clearForm();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    /**
     * Get List Uom
     */
    getListUom() {
      this.$Progress.start();
      getMasterUomList()
        .then(response => {
          for (let i in response.data.data) {
            this.uoms.push({
              label: response.data.data[i].name,
              value: response.data.data[i].id
            });
          }
        })
        .catch(error => {
          this.$notify({
            title: this.$t("error"),
            text: error.data.message,
            type: "error"
          });
        })
        .then(() => {
          this.$Progress.finish();
        });
    },
    /**
     * Get List Recipe Detail
     */
    getListRecipe() {
      this.$Progress.start();
      getMasterRecipeList()
        .then(response => {
          for (let i in response.data.data) {
            if (parseInt(response.data.data[i].id) !== parseInt(this.id)) {
              this.recipes.push({
                label:
                  response.data.data[i].code + "-" + response.data.data[i].name,
                value: response.data.data[i].id
              });
              this.recipe_list.push(response.data.data[i]);
            }
          }
        })
        .catch(error => {
          this.$notify({
            title: this.$t("error"),
            text: error.data.message,
            type: "error"
          });
        })
        .then(() => {
          this.$Progress.finish();
        });
    },
    /**
     * Get List Recipe Detail
     */
    getListRecipeDetailDefault() {
      this.$Progress.start();
      let param = {
        recipe_id: parseInt(this.id)
      };
      getMasterRecipeDetailByRecipe(param)
        .then(response => {
          for (let i in response.data.data) {
            this.recipe_details.push(response.data.data[i]);
            let bg_color = "";
            if (
              typeof response.data.data[i].other_recipe_id != "undefined" &&
              response.data.data[i].other_recipe_id
            ) {
              bg_color = "success";
            }
            this.index = parseInt(i);
            this.data_table.push({
              recipe_or_material_code: response.data.data[i].code,
              recipe_or_material_name: response.data.data[i].name,
              weight: response.data.data[i].weight,
              uom: response.data.data[i].uom,
              usage_detail: response.data.data[i].usage,
              status: response.data.data[i].is_active,
              detail_price: response.data.data[i].price,
              // action: this.index,
              _rowVariant: bg_color
            });
          }
        })
        .catch(error => {
          this.$notify({
            title: this.$t("error"),
            text: error.data.message,
            type: "error"
          });
        })
        .then(() => {
          this.$Progress.finish();
        });
    },
    /**
     * Get Material
     */
    getMaterial() {
      for (let i in this.list_materials) {
        if (this.list_materials[i].id == this.popup.material.value) {
          this.material = this.list_materials[i];
        }
      }
    },
    /**
     * Get List Materials
     */
    getListMaterials() {
      this.$Progress.start();
      getMasterMaterialList()
        .then(response => {
          for (let i in response.data.data) {
            this.materials.push({
              label:
                response.data.data[i].code + "-" + response.data.data[i].name,
              value: response.data.data[i].id
            });
          }
          this.list_materials = response.data.data;
        })
        .catch(error => {
          this.$notify({
            title: this.$t("error"),
            text: error.data.message,
            type: "error"
          });
        })
        .then(() => {
          this.$Progress.finish();
        });
    },

    /**
     * Get details of object
     */
    getDetails() {
      this.$Progress.start();
      let params = {
        id: parseInt(this.id)
      };
      get(params)
        .then(response => {
          this.item = response.data.data;
        })
        .catch(error => {
          this.$notify({
            title: this.$t("error"),
            text: error.data.message,
            type: "error"
          });
        })
        .then(() => {
          this.$Progress.finish();
        });
    },
    /**
     * Update item info to server
     */
    updateItem() {
      this.$Progress.start();
      let recipe = Object.assign({}, this.item);
      recipe.uom_id = this.item.uom_id.value;
      let data = {
        recipe: recipe,
        recipe_details: this.recipe_details
      };
      update(data)
        .then(response => {
          this.$notify({
            title: this.$t("success"),
            text: response.data.message,
            type: "success"
          });
          this.$router.push({ name: this.model });
        })
        .catch(error => {
          this.$notify({
            title: this.$t("error"),
            text: error.data.message,
            type: "error"
          });
        })
        .then(() => {
          this.$Progress.finish();
        });
    },
    /**
     * Create item info to server
     */
    createItem() {
      this.$Progress.start();
      let recipe = Object.assign({}, this.item);
      if (recipe.uom_id != false) {
        recipe.uom_id = this.item.uom_id.value;
      }
      let data = {
        recipe: recipe,
        recipe_details: this.recipe_details
      };
      create(data)
        .then(response => {
          this.$notify({
            title: this.$t("success"),
            text: response.data.message,
            type: "success"
          });
          this.$router.push({ name: this.model });
        })
        .catch(error => {
          this.$notify({
            title: this.$t("error"),
            text: error.data.message,
            type: "error"
          });
        })
        .then(() => {
          this.$Progress.finish();
        });
    },

    setRecipes() {
      this.$set(this, 'recipes', filter(this.recipes, o => o.label.split('-')[0] !== this.item.code))
    },
  },
  created: function() {
    this.getListUom();
    this.getListRecipe();
    this.getListMaterials();
    if (this.id != null) {
      this.getDetails();
      this.getListRecipeDetailDefault();
    } else {
      this.item.id = "";
    }
  },
  watch: {
    "popup.material": function() {
      this.getMaterial();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/master_recipe/Form.vue